/**
 * @generated SignedSource<<07891ac2e80a6d2f473cc6804e0a7ace>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sourcesPage_Query$variables = Record<PropertyKey, never>;
export type sourcesPage_Query$data = {
  readonly qboConnectionStatus: {
    readonly companyName: string | null | undefined;
    readonly connectUrl: string | null | undefined;
    readonly connected: boolean;
    readonly realmId: string | null | undefined;
  };
  readonly qboPnlTags: ReadonlyArray<{
    readonly acctSubType: string | null | undefined;
    readonly name: string;
    readonly pnlLine: string | null | undefined;
    readonly provisional: boolean;
    readonly qboAccountId: string;
  }>;
  readonly sourcesOverview: {
    readonly accounts: ReadonlyArray<{
      readonly bankAccount: {
        readonly id: string;
        readonly nickname: string;
        readonly number: string;
      };
      readonly fileCount: number;
      readonly kind: string;
      readonly lastUploadAt: any | null | undefined;
      readonly qboMapped: boolean;
      readonly qboSourcedCount: number;
      readonly statementRanges: ReadonlyArray<{
        readonly from: string;
        readonly to: string;
      }>;
      readonly witnessedCount: number;
    }>;
    readonly qboFrom: string | null | undefined;
    readonly qboTo: string | null | undefined;
    readonly unionActivatedAt: string | null | undefined;
  } | null | undefined;
  readonly sourcingReview: {
    readonly countedSumCents: number;
    readonly run: {
      readonly status: string;
    } | null | undefined;
    readonly totalCount: number;
    readonly uncountedSumCents: number;
  } | null | undefined;
};
export type sourcesPage_Query = {
  response: sourcesPage_Query$data;
  variables: sourcesPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connected",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "realmId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connectUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboAccountId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "acctSubType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pnlLine",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provisional",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboFrom",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboTo",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unionActivatedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboMapped",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileCount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastUploadAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "witnessedCount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboSourcedCount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccount",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nickname",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "from",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countedSumCents",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uncountedSumCents",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountJob",
  "kind": "LinkedField",
  "name": "run",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "sourcesPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QboConnectionStatus",
        "kind": "LinkedField",
        "name": "qboConnectionStatus",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "QboPnlTag",
        "kind": "LinkedField",
        "name": "qboPnlTags",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SourcesOverview",
        "kind": "LinkedField",
        "name": "sourcesOverview",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SourcesAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SourcesCoverageRange",
                "kind": "LinkedField",
                "name": "statementRanges",
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SourcingReview",
        "kind": "LinkedField",
        "name": "sourcingReview",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "sourcesPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QboConnectionStatus",
        "kind": "LinkedField",
        "name": "qboConnectionStatus",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v18/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "QboPnlTag",
        "kind": "LinkedField",
        "name": "qboPnlTags",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v18/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SourcesOverview",
        "kind": "LinkedField",
        "name": "sourcesOverview",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SourcesAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SourcesCoverageRange",
                "kind": "LinkedField",
                "name": "statementRanges",
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SourcingReview",
        "kind": "LinkedField",
        "name": "sourcingReview",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a854ff95d26bd46097728085f414dc56",
    "id": null,
    "metadata": {},
    "name": "sourcesPage_Query",
    "operationKind": "query",
    "text": "query sourcesPage_Query {\n  qboConnectionStatus {\n    connected\n    realmId\n    companyName\n    connectUrl\n    id\n  }\n  qboPnlTags {\n    qboAccountId\n    name\n    acctSubType\n    pnlLine\n    provisional\n    id\n  }\n  sourcesOverview {\n    qboFrom\n    qboTo\n    unionActivatedAt\n    accounts {\n      kind\n      qboMapped\n      fileCount\n      lastUploadAt\n      witnessedCount\n      qboSourcedCount\n      bankAccount {\n        id\n        number\n        nickname\n      }\n      statementRanges {\n        from\n        to\n        id\n      }\n      id\n    }\n    id\n  }\n  sourcingReview {\n    totalCount\n    countedSumCents\n    uncountedSumCents\n    run {\n      status\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8512eaa52e33c86c67f3c974390e530";

export default node;
